module.exports = __webpack_public_path__ + "img/logo-menu.67e6b652.png";